import { IObservationResult, ICreateObservationBody } from "../services/observationService";
import IObservation, { INewObservation, isObservationStatus, EObservationStatus } from "../interfaces/IObservation";
import { gateBooleanToBoolean, booleanToGateBoolean } from "../../sg-core/utils/GateSupport";
import { base64ToJson, jsonToBase64 } from "../../sg-core/utils/json.helpers";


const ObservationMapper = {
    apiToDomain: (api: IObservationResult["havainto"]): IObservation => {
        const { formSchema, ...decodedData } = api.lomakedata ? base64ToJson(api.lomakedata) : { formSchema: {} }
        return {
            id: api.id,
            guid: api.guid,
            name: api.otsikko || (api as any).nimi,
            creator: api.kirjaaja,
            formType: api.lomake,
            target: api.alue as any,
            work: api.tyo,
            status: isObservationStatus(api.tila) ? api.tila : EObservationStatus.Unknown,

            // use of decodedData here only for testing before API provides them otuside of formData.
            title: api.otsikko || decodedData.otsikko, //|| api.nimi,
            description: api.kuvaus || decodedData.kuvaus,
            image: api.kuva || decodedData.kuva,
            mapLocation: api.karttasijainti,

            formData: {
                otsikko: api.otsikko,
                kuvaus: api.kuvaus,
                on_julkinen: api.on_julkinen,
                ...decodedData,
                sijainti: api.alue,
                kohde: api.alue,
                karttasijainti: { marker: api.karttasijainti },
                kuva: api.kuva ? [{ id: api.kuva, name: "" }] : [],
                tila: api.tila, // !important that status is not provided from formData
            },
            formSchema,
            is_public: gateBooleanToBoolean(api.on_julkinen),
            isEditor: api.on_kasittelija ? gateBooleanToBoolean(api.on_kasittelija) : false,
            created_at: api.kirjattu,
            editor: api.kasittelija,
            searchText: api.lomakedatahaku
        }
    },

    domainToApi: (domain: IObservation): IObservationResult["havainto"] => {
        const { otsikko, kuvaus, kuva, sijainti, kohde, tila, on_julkinen, processMarkings, ...restOfFormData } = domain.formData;
        const kuvaId = kuva && kuva[0] ? kuva[0].id : domain.image || "";

        return {
            id: domain.id,
            guid: domain.guid,
            // nimi: domain.name,
            otsikko: otsikko || domain.title,
            kuvaus: kuvaus || domain.description,
            kuva: kuvaId || undefined,
            karttasijainti: domain.mapLocation || undefined,

            kirjaaja: domain.creator,
            lomake: domain.formType,
            tyo: domain.work || undefined,
            tila: tila || domain.status,
            kirjattu: domain.created_at,
            alue: sijainti || kohde || domain.target,
            on_julkinen: booleanToGateBoolean(domain.is_public),
            kasittelija: domain.editor || undefined,
            lomakedata: jsonToBase64({
                formSchema: domain.formSchema,
                ...restOfFormData,
                otsikko,
                kuvaus,
                kuva
            }),
            lomakedatahaku: jsonToBase64(domain.searchText as any)
        }
    },
};

export default ObservationMapper

export const NewObservationMapper = {
    domainToApi: (domain: INewObservation): ICreateObservationBody["havainto"] => {
        const kuvaId = domain.formData.kuva && domain.formData.kuva[0] ? domain.formData.kuva[0].id : "";
        const { sijainti, kohde, ...restOfFormData } = domain.formData;

        return {
            otsikko: domain.formData.otsikko || domain.name,
            kuvaus: domain.formData.kuvaus,
            kuva: kuvaId,
            lomake: domain.formType,
            tila: domain.status,
            kirjattu: domain.created_at,
            alue: sijainti || kohde,
            on_julkinen: domain.is_public ? "Y" : "N",
            lomakedata: jsonToBase64({ formSchema: domain.formSchema, ...restOfFormData }),
            karttasijainti: domain.formData.karttasijainti?.marker,
            lomakedatahaku: jsonToBase64(domain.searchText as any)
        }
    },
};